import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ketamine-vs-spravato-essentials")({
  beforeLoad: () => {
    throw redirect({ to: "/spravato-vs-ketamine", replace: true });
  },
});
